module.exports = __webpack_public_path__ + "media/images/glyphs/profile-50d8c36adeb87f071cb5be766e928b60.svg";